import { ListHeader } from '@/components/List'
import { Sorter } from './components/Sorter'
import { Filter } from './components/Filter'
import { Title } from './components/Title'

export function Header() {
  return <ListHeader title={<Title />} sorter={<Sorter />} filter={<Filter />} />
}
